export default __webpack_public_path__ + "static/media/delete.654210ff.svg";